import React from 'react'
import styles from './index.scss'

const links = [
  { url: 'http://www.n8n8.cn/', name: '经传多赢' },
  { url: 'http://www.yidejia.com/', name: '伊的家商城' },
  { url: 'https://meimeifa.com/', name: '创富学院' },
]

const copyright = [
  `版权所有：经传集团`,
  `客服电话：4007003809`,
  `Powered by：www.jingzhuan.cn`,
  `© 2016-${new Date().getFullYear()} 粤ICP备11037409号-3`,
]

const AppFooter = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.footerInner}>
        <span>友情链接:</span>
        {links.map(({ url, name }, idx) => (
          <span key={idx}>
            <a href={url} target="_blank">
              {name}
            </a>
          </span>
        ))}
      </div>
      <div className={styles.footerInner}>
        {copyright.map((v, idx) => (
          <span key={idx}>{v}</span>
        ))}
      </div>
    </div>
  )
}

export default AppFooter
